
export default {
  name: 'ChampionTrophy',
  props: {
    size: {
      type: String,
      default: '25',
    },
  },
  computed: {
    gradientId() {
      return `champion-trophy-gradient-${this._uid}`;
    },
    filterId() {
      return `champion-trophy-shadow-${this._uid}`;
    },
    width() {
      return this.size;
    },
    height() {
      return Number(this.size) * (22.357 / 23.999);
    },
  },
};
